import { render } from "./AiReportQuarter.vue?vue&type=template&id=73074c4d&ts=true"
import script from "./AiReportQuarter.vue?vue&type=script&lang=ts"
export * from "./AiReportQuarter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__